import type { ComponentProps } from "react"
import { SelectSeparator as SelectSeparatorBase } from "@/v2-ui/select/base/SelectBase"
import cn from "@/v2-ui/utils/utils.cn"

export type SelectSeparatorProps = ComponentProps<typeof SelectSeparatorBase>

function SelectSeparator(props: SelectSeparatorProps) {
  const { className, ...selectSeparatorBaseProps } = props
  return (
    <SelectSeparatorBase
      className={cn("ui-select-separator", className)}
      {...selectSeparatorBaseProps}
    />
  )
}

export default SelectSeparator
